const MYTHS = [
  {
    title: "“Logo 和页面一样，就一定是真的”",
    body: "外观最容易复制，骗子只需截图或套用模板就能以假乱真。真正要核的是域名、备案与行为，而不是页面长得多像。",
  },
  {
    title: "“从搜索点进去的一定是官网”",
    body: "竞价广告位与仿冒站点都可能出现在搜索结果前列。看到链接，仍要回到域名与备案这一步做确认。",
  },
  {
    title: "“有官方 App 就不会遇到假站”",
    body: "假站同样可能伪装成“官方客户端”下载链接。请只在应用商店或官网公布的下载入口获取，并核对开发者与包名。",
  },
  {
    title: "“只要不付钱就不会被骗”",
    body: "不少仿冒站真正的目的是套取账号与隐私，再用你的身份去贷款、洗钱或盗刷，损失往往比直接转账更隐蔽、更严重。",
  },
];

export default function Myths() {
  return (
    <section aria-labelledby="myths-heading" className="border-y border-background-200">
      <div className="wrap py-10 md:py-14">
        <div className="max-w-2xl">
          <p className="kicker mb-3">
            <i className="ri-question-answer-line"></i>
            认知误区
          </p>
          <h2 id="myths-heading" className="font-heading text-2xl text-foreground-950 md:text-3xl">
            别被这四个常见误解带偏
          </h2>
          <p className="mt-3 text-[15px] leading-7 text-foreground-700">
            很多人不是不会查，而是被一些“想当然”的判断耽误。先纠正直觉，再谈方法，防骗意识才能真正到位。
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {MYTHS.map((m, i) => (
            <article key={m.title} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="font-heading text-4xl leading-none text-primary-200">“{i + 1}”</span>
              <div>
                <h3 className="font-heading text-lg leading-snug text-foreground-950">{m.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-700">{m.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}